import { render, staticRenderFns } from "./ChangeSite.vue?vue&type=template&id=3ff62812&"
import script from "./ChangeSite.vue?vue&type=script&lang=js&"
export * from "./ChangeSite.vue?vue&type=script&lang=js&"
import style0 from "./ChangeSite.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports